import type {
  ShiftFormManagerDashboardFilters,
  ShiftProductionDepartmentName,
  ShiftProductionLineName,
} from "../../../shared/shift-production-form/contracts";

/**
 * The user's broad report scope and the drilldown location are deliberately
 * separate. A global shift filter narrows a chart; it never means that the
 * user opened a shift's source forms.
 */
export type AnalysisLocation = {
  departmentName?: ShiftProductionDepartmentName;
  lineName?: ShiftProductionLineName;
  drillShift?: NonNullable<ShiftFormManagerDashboardFilters["shift"]>;
};

export function analysisLocationFilters(
  filters: ShiftFormManagerDashboardFilters,
  location: AnalysisLocation,
): ShiftFormManagerDashboardFilters {
  return {
    ...filters,
    departmentName: location.departmentName,
    lineName: location.lineName,
    shift: location.drillShift ?? filters.shift,
    offset: 0,
  };
}

export function analysisRootLocation(): AnalysisLocation {
  return {};
}

export function analysisDepartmentLocation(departmentName: ShiftProductionDepartmentName): AnalysisLocation {
  return { departmentName };
}

export function analysisLineLocation(
  departmentName: ShiftProductionDepartmentName,
  lineName: ShiftProductionLineName,
): AnalysisLocation {
  return { departmentName, lineName };
}

export function analysisShiftLocation(
  location: AnalysisLocation,
  shift: NonNullable<ShiftFormManagerDashboardFilters["shift"]>,
): AnalysisLocation {
  if (!location.departmentName || !location.lineName) return location;
  return { ...location, drillShift: shift };
}

/** A new report-level shift ends an explicit source-form drilldown. */
export function analysisGlobalShiftLocation(location: AnalysisLocation): AnalysisLocation {
  if (!location.drillShift || !location.departmentName || !location.lineName) return location;
  return analysisLineLocation(location.departmentName, location.lineName);
}

export function isAnalysisTerminal(location: AnalysisLocation) {
  return Boolean(location.lineName && location.drillShift);
}
